module.exports = __webpack_public_path__ + "static/img/about-img.28a0dae6.jpg";